<template>
  <div class="index">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide class="img1">
        <div
          class="text"
          :class="activeIndex == 0 ? 'animate__animated animate__backInDown' :'' "
          v-if="activeIndex == 0"
        >
          <div class="h1">中国儿童呼吸问题</div>
          <div class="h1">一站式解决方案提供商</div>
          <div class="flex justify-around sub-text">
            <span>专人临床运营</span>
            <span>深耕患者社群</span>
            <span>全网媒体宣传</span>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="img2">
        <div
          class="text"
          :class="activeIndex == 1 ? 'animate__animated animate__backInLeft' :'' "
          v-if="activeIndex == 1"
        >
          <div class="h2">雾化器带回家</div>
          <div class="h1">边做游戏边雾化</div>
          <div class="icon">
            <svg
              class="bi bi-arrow-right"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L12.793 8l-2.647-2.646a.5.5 0 0 1 0-.708z"
                clip-rule="evenodd"
              />
              <path
                fill-rule="evenodd"
                d="M2 8a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide class="img3">
        <div
          class="text"
          :class="activeIndex == 2 ? 'animate__animated animate__backInRight' :'' "
          v-if="activeIndex == 2"
        >
          <div class="h2">布咳乐雾化站 百城千店计划</div>
          <div class="h1">整店输出 复制成功</div>
          <div class="con">你选址 我开店 不用干活 把钱赚</div>

          <div class="icon">
            <svg
              class="bi bi-arrow-right"
              viewBox="0 0 16 16"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M10.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L12.793 8l-2.647-2.646a.5.5 0 0 1 0-.708z"
                clip-rule="evenodd"
              />
              <path
                fill-rule="evenodd"
                d="M2 8a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H2.5A.5.5 0 0 1 2 8z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="d-none d-md-block" :style="{height:height60}">
          <div class="new">
            <div class="title">新闻资讯</div>
          </div>

          <div class="container">
            <div class="row new-list">
              <div
                class="new-item col-md-6"
                v-for="(item,index) in newList"
                :key="index"
                @click="jumpArticle(item.url)"
              >
                <div class="item rounded">
                  <div class="img">
                    <img class="rounded img-100" :src="item.imgUrl" alt srcset />
                  </div>
                  <div class="text">
                    <div class="text-cut-2 title">{{item.title}}</div>
                    <!-- <div class="time">2020/05/05</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer-bar class="footer" :style="{height:height40}"></footer-bar>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import FooterBar from "@/components/Footer.vue";
export default {
  components: {
    FooterBar
  },
  data() {
    return {
      height: "",
      height60: "",
      height40: "",
      newList: [
        {
          title:
            "用物联网解构医疗未来，未来医疗6月13日将召开《智雾化 新未来》高峰论坛",
          url: "https://mp.weixin.qq.com/s/4W3zw6KFeq_SQbJpL0qGwQ",
          imgUrl: "http://cdn.yirdoc.com.cn/20200610110529.png",
          date: "2020-06-10",
          con:
            "今日，青岛未来医疗科技有限公司发出了电子邀请函，宣布将于 6 月 13 日在中国江苏南京举办首届-《智雾化 新未来》物联网时代下的雾化变革与新生 高峰论坛，届时将公布年收益百万优质项目与千万补贴经销商计划。"
        },
        {
          title: "国内首个物联网智慧医院全院雾化项目落地郑大一附院",
          url: "https://mp.weixin.qq.com/s/XECAN83nL0fxb4zY96sDoQ",
          imgUrl: "http://cdn.yirdoc.com.cn/zhengdayi.png",
          date: "2020-05-19",
          con: "2020年4月底，布咳乐雾化站正式进驻郑州大学第一附属医院啦!"
        }
      ],

      activeIndex: 0,
      swiperOptions: {
        pagination: {
          el: ".swiper-pagination"
        },
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        direction: "vertical", //水平方向移动
        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        height: window.innerHeight, // 高度设置，占满设备高度
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true, //将observe应用于Swiper的父元素。当Swiper的父元素变化时，例如window.resize，Swiper更新
        on: {
          slideChangeTransitionEnd: () => {
            this.activeIndex = this.$refs.mySwiper.$swiper.activeIndex;
          }
        }
      },
      newSwiperOptions: {
        pagination: {
          el: ".swiper-pagination"
        },
        direction: "horizontal", //水平方向移动
        notNextTick: true, //notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        grabCursor: false, //鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
        setWrapperSize: true, //Swiper使用flexbox布局(display: flex)，开启这个设定会在Wrapper上添加等于slides相加的宽或高，在对flexbox布局的支持不是很好的浏览器中可能需要用到。
        autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化
        slidesPerView: 1, //设置slider容器能够同时显示的slides数量(carousel模式)。可以设置为数字（可为小数，小数不可loop），或者 'auto'则自动根据slides的宽度来设定数量。loop模式下如果设置为'auto'还需要设置另外一个参数loopedSlides。
        mousewheel: true, //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，默认值false
        mousewheelControl: true, //同上
        resistanceRatio: 0, //抵抗率。边缘抵抗力的大小比例。值越小抵抗越大越难将slide拖离边缘，0时完全无法拖离。本业务需要
        observeParents: true //
      }
    };
  },
  beforeMount() {
    const that = this;
    var w = document.documentElement.clientWidth || document.body.clientWidth;
    if (w > 992) {
      that.height60 = "50%";
      that.height40 = "50%";
    } else {
      that.height60 = "0%";
      that.height40 = "100%";
    }
    window.onresize = () => {
      var w = document.documentElement.clientWidth || document.body.clientWidth;
      if (w > 992) {
        that.height60 = "50%";
        that.height40 = "50%";
      } else {
        that.height60 = "0%";
        that.height40 = "100%";
      }
    };
  },
  methods: {
    jumpArticle(url) {
      window.open(url, "_blank");
    },
    jump(url) {
      localStorage.setItem("activeIndex", url);
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
.index {
  margin-top: -80px !important;
}

.new-item {
  cursor: pointer;
}

.new {
  .title {
    text-align: center;
    color: #363636;
    font-size: 40px;
    padding: 20px 0;
  }
}

@media (max-width: 992px) {
  .index {
    margin-top: -60px !important;
  }
  .footer {
    padding-top: 60px;
  }
}

@media (min-width: 1366px) {
  .img2 {
    .text {
      left: 300px;
    }
  }

  .new {
    .title {
      text-align: center;
      color: #363636;
      font-size: 30px;
      padding: 10px 0;
    }
  }

  .footer {
    display: inherit;
  }

  .img3 {
    .text {
      position: absolute;
      right: 270px;
    }
  }
}
</style>


